import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (state?: boolean) =>
  createStyles({
    publishSchedule: {
      backgroundColor: palette.lightGray,
      borderRadius: 25,
      padding: 4,
      marginLeft: 8,
      alignItems: 'center',
      display: 'flex',
      cursor: 'pointer',
      '&>span': {
        margin: '0',
        padding: '0',
        color: palette.darkGray,
        fontWeight: 500,
        display: 'inline-block',
        overflow: 'hidden',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        maxWidth: '0',
        transition: 'max-width 0.1s ease-out',
        fontFamily: 'Roboto',
        fontSize: 14,
        '&::before': { content: "''", marginLeft: 4 },
      },
      '&:hover, &:active': {
        '&>span': {
          maxWidth: 450,
          transition: 'max-width 0.2s ease-in',
          marginRight: 4,
        },
      },
    },
    publishScheduleIcon: {
      fontSize: 20,
      color: palette.darkGray,
    },
    actionHeader: {
      width: '10%',
      justifyContent: 'center',
      textAlign: 'center',
    },
    rowAllRows: {
      width: '64%',
      fontSize: 12,
    },
    resourcesCard: {
      border: `1px solid ${palette.borderGray}`,
      borderRadius: 8,
      padding: 8,
      margin: '6px 0px',
    },
    cardTitle: { color: palette.darkGray, fontSize: 14, marginLeft: 4 },
    cardGridTitle: { alignItems: 'center', display: 'flex' },
    options: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
    container: {
      display: 'flex',
      alignItems: 'center',
      padding: 15,

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    tableRow: {
      width: 100,
      paddingRight: 0,
      paddingLeft: 16,
      fontSize: 12,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    state: {
      width: 50,
      fontSize: 12,
    },
    stateSmall: {
      width: 65,
      fontSize: 12,
    },
    stateLarge: {
      width: 110,
      fontSize: 12,
    },
    title: {
      fontSize: 12,
    },
    cellContent: {
      display: 'flex',
      alignItems: 'center',
      color: palette.darkGray,
      justifyContent: 'center',
      '& .MuiOutlinedInput-root': {
        height: 25,
        borderColor: palette.blue,
        width: 90,
      },
      '& .MuiOutlinedInput-input': { height: 25, width: 90 },
      '& .MuiOutlinedInput-adornedEnd': { paddingRight: 2 },
    },
    limitLicenseText: {
      fontSize: 12,
      textDecoration: 'line-through',
    },
    buttons: { marginTop: 15 },
    switchContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 8,
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchText: {
      fontSize: 12,
      fontWeight: 500,
      color: state ? palette.darkGreen : palette.darkRed,
    },
    activeAllText: {
      fontSize: 15,
      fontWeight: 500,
    },
    activeAllTextForm: {
      fontSize: 15,
      fontWeight: 500,
      margin: '22px 0px 4px 0px',
    },
    emailAdminOptionTextSelected: {
      fontSize: 15,
      fontWeight: 500,
      color: palette.green,
    },
    checkboxCell: {
      width: '10%',
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },
    checkboxActivateAll: {
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: state ? palette.green : palette.red,
      },
    },
    checkboxActivateAllVirtualizer: {
      marginTop: 8,
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: state ? palette.green : palette.red,
      },
    },
    fields: {
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
      '& .MuiGrid-item': { padding: '8px 0px' },
    },
    fieldsLicenses: {
      flexDirection: 'row',
      display: 'flex',
      flexWrap: 'nowrap',
      '& .MuiFormControl-fullWidth': { margin: '6px 0px' },
      '& .MuiOutlinedInput-multiline': { display: 'inline-table', padding: 14 },
      '& .MuiGrid-item': { padding: '1px 6px' },
    },
    deleteButtons: {
      marginTop: '15px !important',
    },
    bold: { fontWeight: 'bold' },
    titleGrid: {
      padding: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: 8,
      margin: '4px 0px',
    },
    autocompleteCompany: {
      cursor: 'pointer',
      width: '100%',
      display: 'flex',
      borderColor: palette.borderGray,
      padding: '0px 0px 0px 4px !important',

      '& .MuiButton-label': { justifyContent: 'flex-start' },
    },
    errorSamePartnerButton: { borderColor: palette.red },
    itemSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    companyCell: {
      width: 150,
      minWidth: 150,
      maxWidth: 150,
      cursor: 'pointer',
      padding: '0px 0px 0px 16px',
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
    },
    name: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 200,
      minWidth: 200,
      maxWidth: 200,
    },
    selectClientButton: { padding: 0 },
    expandIcon: { fontSize: '25px !important' },
    stepIconComplete: {
      color: palette.green,
      backgroundColor: 'white',
      borderRadius: '50%',
      position: 'relative',
      transition: 'all 0.7s ease-in-out',
    },
    stepIcon: {
      color: palette.sideGray,
      backgroundColor: 'white',
      borderRadius: '50%',
    },
    progressLine: {
      color: palette.sideGray,
      opacity: 0.6,
      alignItems: 'flex-start',
      display: 'flex',
      marginBottom: 20,
    },
    progressLineComplete: {
      color: palette.green,
      alignItems: 'flex-start',
      display: 'flex',
      marginBottom: 20,
      transition: 'all 0.5s ease-in-out',
    },
    stepLabel: { fontSize: 11 },
    stepLabelConfirm: { marginLeft: '-20px', fontSize: 11 },
    stepsGrid: {
      textAlign: 'center',
      display: 'block',
      margin: '-35px !important',
    },
    optionsCard: { display: 'flex', alignItems: 'center' },
    optionsEmailAdmin: {
      margin: 8,
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${palette.gray}`,
      cursor: 'pointer',
      borderRadius: 30,
      '& .MuiCheckbox-root': { padding: '0px 2px 0px 0px !important' },
    },
    optionsEmailAdminSelected: {
      border: `1px solid ${palette.green}`,
      cursor: 'pointer',
      backgroundColor: palette.lightGreen,
    },
    successIcon: { color: palette.green },
    valuesForm: {
      justifyContent: 'flex-start',
    },
    valuesFormLicenses: {
      justifyContent: 'center',
      '& .MuiOutlinedInput-input': {
        textAlign: 'center',
        fontSize: 16,
        height: 35,
      },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': {
        color: palette.deepBlue,
        fontWeight: 500,
        width: 90,
        height: 35,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
    },

    valuesFormLicensesError: {
      justifyContent: 'flex-start',
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.red,
        fontWeight: 500,
      },
      '& .MuiOutlinedInput-root': { color: palette.red, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.red,
        border: `2px solid ${palette.red}`,
      },
    },
    virtualizerConfirm: { display: 'block' },
    activeAllTextLicenses: {
      fontSize: 14,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      marginRight: 4,
    },
    fieldsLicensesApplied: {
      backgroundColor: palette.superLightGreen,
      border: `1px solid ${palette.superLightGreen} `,
      borderRadius: 8,
    },
    checkIcon: { fontSize: 20, color: palette.green },
    ghostCheckIcon: { fontSize: 0, color: palette.white },
    checkbox: {
      margin: '0px 6px 0px 0px !important',
      width: 5,
      height: 5,
      '& .MuiCheckbox-colorSecondary.Mui-checked': {
        color: palette.green,
      },
      '& .MuiSvgIcon-root': { width: '0.8em', height: '0.8em' },
    },
    maxLicenseAvailable: {
      fontSize: 12,
      color: palette.red,
      fontWeight: 500,
      margin: 6,
    },
    maxLicenseAvailableGrid: {
      marginTop: 24,
      borderRadius: 18,
      padding: '0px !important',
      backgroundColor: palette.superLightRed,
      display: 'flex',
      alignItems: 'center',
    },
    errorIcon: { fontSize: 16, color: palette.red, paddingLeft: 6 },
    alert: { marginTop: 16 },
  });

export const overrideModal = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    maxHeight: '100%',
    overflowX: 'auto',
  },
};

export const overrideSwitch = (state): any => ({
  switchContainer: {
    marginBottom: 16,
    padding: 0,
    justifyContent: 'center',
    '& .MuiFormControlLabel-root': {
      marginRight: 0,
      paddingRight: 16,
      backgroundColor: state ? palette.superLightGreen : palette.superLightRed,
      borderRadius: 25,
    },
    '& .MuiSwitch-track': {
      backgroundColor: ` ${
        state ? palette.darkGreen : palette.darkRed
      } !important`,
      opacity: '0.4 !important',
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: state ? palette.darkGreen : palette.darkRed,
    },
  },
});
